import { IFeature } from 'mod/featureV2/interface';

const image = {
    src: 'asset/width-3840/picture/eba58330bfafdde773c90779dd8973e1.png',
    // width: 900,
    // height: 640,
    width: 3840,
    height: 1860,
};
const text = 'Bala Bala Bala Bala.<br>Bala <strong class="g-highlight">Bala Bala</strong> Bala Bala <a href="/">Bala</a> Bala Bala Bala Bala Bala Bala Bala Bala Bala Bala';
const card = '<div class="g-card">Bala Bala Bala Bala.<br>Bala <strong class="g-highlight">Bala Bala</strong> Bala Bala <a href="/">Bala</a> Bala Bala Bala Bala Bala Bala Bala Bala Bala Bala</div>';

export const collapse: IFeature = {
    moduleId: 'collapse',
    type: 'collapse',
    title: 'collapse',
    config: {
        defaultShowLength: 3,
        showMoreText: 'View More >',
        showLessText: 'View Less >',
        defaultActiveKeys: [1],
        accordion: false,
    },
    list: [
        {
            title: 'Example for Image',
            content: [image]
        },
        {
            title: 'Example for Text',
            content: [text]
        },
        {
            title: 'Image for Image and Text',
            content: [image, card, image, text]
        },
        {
            title: 'In Less',
            content: [text]
        },

    ]
};

export const collapse2: IFeature = {
    ...collapse,
    moduleId: 'collapse2',
    title: 'faqs - collapse2',
    config: {
        accordion: true,
    },
};